import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthContainerComponent } from '../_components/auth-container.component';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { hasControlError } from '@hp-core/adapters/cybertron.adapter';
import { HlmInputDirective } from '@helipagos-ng/ui-input-helm';
import { HlmLabelDirective } from '@helipagos-ng/ui-label-helm';
import { AuthCodeDirective } from '../_directives/auth-code.directive';

@Component({
  selector: 'lib-validate-code',
  standalone: true,
  imports: [
    CommonModule,
    AuthContainerComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    HlmInputDirective,
    HlmLabelDirective,
    AuthCodeDirective,
  ],
  templateUrl: './validate-code.component.html',
})
export class ValidateCodeComponent {
  protected readonly codeControl = new FormControl('', [
    Validators.required,
    Validators.minLength(6),
  ]);
  protected loading = false;

  protected validateCode(value: string) {
    console.log('validate code');
  }

  protected hasError(errorName: string = 'required'): boolean {
    return hasControlError(this.codeControl, errorName);
  }
}
